import { useEffect } from 'react';
import { Features, isFeatureEnabled } from '../features';

const FIXED_CLASSES_TO_ADD: ReadonlyArray<string> = [Features.Uirefresh];
const getClassesToAdd = (): ReadonlyArray<string> => {
  const classes: Array<string> = [...FIXED_CLASSES_TO_ADD];

  for (const value of Object.values(Features)) {
    const isActive = isFeatureEnabled(value);
    if(isActive) {
      classes.push(value);
    }
  }

  return classes;
};

export const useClassAppender = (): void => {
  useEffect(() => {
    const classes = getClassesToAdd();
    document.body.classList.add(...classes);
  }, []);
};
